import React, { useEffect, useMemo, useState } from "react";
import {Link} from 'react-router-dom';
import Header from "./Header";
import Footer from "./Footer";
import axios from "axios";
import { uploadUrl } from "./uploadUrl";
import {Helmet} from 'react-helmet';
import WhatsAppButton from './whatsapp';
import Chat from './chat';
import Call from './call';
import Marquee from './marquee';


const DesignIdeas = () => {
  const [selectedDesignId, setSelectedDesignId] = useState(null);
  const [designIdeas, setDesignIdeas] = useState([]);
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [visiblecount, setvisiblecount] = useState(6);

  
  useEffect(() => {
    const fetchData = async () => {
       const userId = localStorage.getItem('userId') || (JSON.parse(localStorage.getItem('user') || 'null')?.id);

    if (!userId) {
      alert('Login to see your loved data ');
    }
      try {
        setLoading(true);

        const res = await axios.get(
          `https://api.squareandangle.pranatigroup.in/api/admin/loved/${userId}`
        );

        setDesignIdeas(res.data.rows);
      } catch (e) {
        setError(
          e?.response?.data?.message ||
            "Failed to load design ideas"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

 
  useEffect(() => {
    if (!selectedDesignId) return;

    const fetchRelated = async () => {
      try {
        const res = await axios.get(
          `https://api.squareandangle.pranatigroup.in/api/admin/relatedmore/${selectedDesignId}`
        );

        setRelated(res.data.rows);
      } catch (e) {
        console.log(e);
      }
    };

    fetchRelated();
  }, [selectedDesignId]);


  const selectedDesign = useMemo(() => {
    return (
      designIdeas.find(
        (item) => item.id === selectedDesignId
      ) || null
    );
  }, [selectedDesignId, designIdeas]);

   const remove=async(id)=>{

    try{
      await axios.post(`https://api.squareandangle.pranatigroup.in/api/admin/removeselections/${id}`);
     
    setDesignIdeas((prev)=>
    prev.filter((item)=>item.id !=id)
    );

    if(selectedDesignId==id){
      setSelectedDesignId(null);
    }
    }catch(error){
      console.log(error);
    }
    
   }


  return (
    <>
      <div className="app">
        <Header />
        <Marquee/>
           <Helmet>
        <title>Pranati Interior - Kolkata best Interior</title>
        <meta name="description" content="Welcome to Kolkata best interior" />

        <link rel="canonical" href="https://squareandangle.pranatigroup.in/design_ideas" />

        <meta property="og:title" content="Pranati interior" />
        <meta property="og:description" content="Kolkata best Interior" />
        <meta property="og:image" content="/images/preview.png" />
        <meta property="og:url" content="https://squareandangle.pranatigroup.in/design_ideas" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Pranati interior" />
        <meta name="twitter:description" content="Kolkata best Interior" />
        <meta name="twitter:image" content="/images/preview.png" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Pranati Interior",
            "url": "https://squareandangle.pranatigroup.in/design_ideas",
            "description": "Kolkata best Interior",
            "image": "https://squareandangle.pranatigroup.in/images/preview.png",
            "areaServed": "Kolkata",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Kolkata",
              "addressRegion": "West Bengal",
              "addressCountry": "IN"
            }
          })}
        </script>
      </Helmet>
    
        <div className="breadcumb-area black-opacity bg-img-6">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="breadcumb-wrap">
                  <h2>Choice Gallery</h2>

                  <ul>
                    <li>
                      <a href="index.html">Home</a>
                    </li>

                    <li>/</li>

                    <li>Choice Gallery</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="service-area bg-1 design-gallery-area">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="section-title text-center">
                  <h2>Choice Gallery</h2>

                  <h3>
                    Explore our latest design ideas
                  </h3>
                </div>
              </div>
            </div>

           <div className="row g-4">
  {loading ? (
    /* ================= LOADING ================= */
    <div className="col-12 text-center">
      <div
        style={{
          padding: "60px 20px",
          color: "#666",
          fontSize: "16px",
          fontWeight: "500",
        }}
      >
        Loading...
      </div>
    </div>
  ) : error ? (
    /* ================= ERROR ================= */
    <div className="col-12 text-center">
      <div
        style={{
          padding: "60px 20px",
          color: "#dc3545",
          fontSize: "16px",
          fontWeight: "500",
        }}
      >
        {error}
      </div>
    </div>
  ) : designIdeas.length === 0 ? (
    /* ================= EMPTY ================= */
    <div className="col-12 text-center">
      <div
        style={{
          padding: "60px 20px",
          color: "#777",
          fontSize: "16px",
        }}
      >
        No design ideas found.
      </div>
    </div>
  ) : (
    /* ================= DESIGN LIST ================= */
    designIdeas.slice(0, visiblecount).map((item) => (
      <div
        className="col-12 col-sm-6 col-lg-4"
        key={item.id}
        style={{
          display: "flex",
          marginBottom: "10px",
        }}
      >
        {/* ================= CARD ================= */}
        <div
          style={{
            width: "100%",
            height: "100%",
            background: "#fff",
            borderRadius: "16px",
            overflow: "hidden",
            border: "1px solid #e9e9e9",
            boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
            display: "flex",
            flexDirection: "column",
            transition: "all 0.3s ease",
          }}
        >
          {/* ================= IMAGE AREA ================= */}
          <div
            onClick={() => setSelectedDesignId(item.id)}
            style={{
              position: "relative",
              width: "100%",
              height: "280px",
              overflow: "hidden",
              cursor: "pointer",
              background: "#f5f5f5",
            }}
          >
            {/* ================= REMOVE BUTTON ================= */}
            <button
              type="button"
              aria-label="Remove design"
              onClick={(e) => {
                e.stopPropagation();
                remove(item.id);
              }}
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                width: "34px",
                height: "34px",
                border: "none",
                borderRadius: "50%",
                background: "rgba(0,0,0,0.72)",
                color: "#fff",
                fontSize: "21px",
                lineHeight: "1",
                fontWeight: "500",
                cursor: "pointer",
                zIndex: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 0,
              }}
            >
              ×
            </button>

            {/* ================= DESIGN IMAGE ================= */}
            <img
              src={uploadUrl(item.image)}
              alt={item.description || "Design"}
              style={{
                width: "100%",
                height: "100%",
                display: "block",
                objectFit: "cover",
                objectPosition: "center",
              }}
            />

            
          </div>

          {/* ================= CARD BODY ================= */}
          <div
            style={{
              padding: "18px",
              display: "flex",
              flexDirection: "column",
              flex: 1,
            }}
          >
            {/* ================= DESCRIPTION ================= */}
            <h3
              style={{
                margin: "0 0 18px",
                color: "#222",
                fontSize: "17px",
                lineHeight: "1.5",
                fontWeight: "600",
                minHeight: "51px",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {item.description || "Design Idea"}
            </h3>

            {/* ================= ACTION BUTTONS ================= */}
            <div
              style={{
                display: "flex",
                gap: "10px",
                marginTop: "auto",
              }}
            >
              {/* VIEW DESIGN */}
              <button
                type="button"
                onClick={() => setSelectedDesignId(item.id)}
                style={{
                  flex: 1,
                  minHeight: "44px",
                  border: "1px solid #222",
                  borderRadius: "8px",
                  background: "#d46c17",
                  color: "#fcf8f8",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "8px 10px",
                  transition: "all 0.25s ease",
                }}
              >
                View Design
              </button>

              {/* GET QUOTE */}
              <a
                href="https://wa.me/06289001010?text=Hello%20I%20want%20more%20details"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  flex: 1,
                  minHeight: "44px",
                  border: "1px solid #25d366",
                  borderRadius: "8px",
                  background: "#25d366",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: "600",
                  textDecoration: "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "8px 10px",
                  transition: "all 0.25s ease",
                }}
              >
                Get Quote
              </a>
            </div>
          </div>
        </div>
      </div>
    ))
  )}

  {/* ================= SEE MORE ================= */}
  {!loading &&
    !error &&
    visiblecount < designIdeas.length && (
      <div
        className="col-12 text-center"
        style={{
          margin: "35px 0 20px",
        }}
      >
        <button
          type="button"
          onClick={() => setvisiblecount(visiblecount + 6)}
          style={{
            padding: "12px 34px",
            border: "none",
            borderRadius: "8px",
            background: "#222",
            color: "#fff",
            fontSize: "15px",
            fontWeight: "600",
            cursor: "pointer",
            boxShadow: "0 5px 15px rgba(0,0,0,0.15)",
          }}
        >
          See More
        </button>
      </div>
    )}
</div>

          </div>
        </div>

        

        {selectedDesign && (
  <div
    onClick={() => setSelectedDesignId(null)}
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.78)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
      padding: "20px",
      overflowY: "auto",
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        width: "1050px",
        maxWidth: "100%",
        maxHeight: "92vh",
        overflowY: "auto",
        background: "#fff",
        borderRadius: "18px",
        boxShadow: "0 25px 80px rgba(0,0,0,0.35)",
      }}
    >
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "22px 28px",
          borderBottom: "1px solid #eee",
        }}
      >
        <div>
          <div
            style={{
              color: "#e85d04",
              fontSize: "11px",
              fontWeight: "700",
              letterSpacing: "1.5px",
              marginBottom: "5px",
            }}
          >
            DESIGN GALLERY
          </div>

          <h2
            style={{
              margin: 0,
              color: "#222",
              fontSize: "25px",
              fontWeight: "700",
            }}
          >
            {selectedDesign.title || "Design Idea"}
          </h2>
        </div>

        <button
          onClick={() => setSelectedDesignId(null)}
          style={{
            width: "38px",
            height: "38px",
            border: "none",
            borderRadius: "50%",
            background: "#f5f5f5",
            color: "#222",
            fontSize: "25px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          ×
        </button>
      </div>

      {/* BODY */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1.1fr 0.9fr",
          gap: "30px",
          padding: "28px",
        }}
      >
        {/* ================= LEFT ================= */}
        <div>
          <div
            style={{
              width: "100%",
              height: "450px",
              overflow: "hidden",
              borderRadius: "14px",
              background: "#f3f3f3",
            }}
          >
            <img
              src={uploadUrl(selectedDesign.image)}
              alt={
                selectedDesign.title ||
                selectedDesign.description ||
                "Interior Design"
              }
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </div>

        
        </div>

        {/* ================= RIGHT ================= */}
        <div>
          <div
            style={{
              color: "#e85d04",
              fontSize: "11px",
              fontWeight: "700",
              letterSpacing: "1.5px",
              marginBottom: "7px",
            }}
          >
            INTERIOR DESIGN
          </div>

          <h3
            style={{
              margin: "0 0 12px",
              color: "#222",
              fontSize: "27px",
              lineHeight: "1.25",
              fontWeight: "700",
            }}
          >
            {selectedDesign.title || "Beautiful Interior Design"}
          </h3>

          <p
            style={{
              color: "#666",
              fontSize: "14px",
              lineHeight: "1.7",
              margin: "0 0 18px",
            }}
          >
            {selectedDesign.description}
          </p>

          {/* GET QUOTE */}
          <a
            href="https://wa.me/06289001010?text=Hello%20I%20want%20more%20details%20about%20this%20interior%20design"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "13px 18px",
              background: "#e85d04",
              color: "#fff",
              textDecoration: "none",
              borderRadius: "7px",
              fontSize: "14px",
              fontWeight: "600",
              marginBottom: "25px",
            }}
          >
            <span>Get Quote</span>
            <span style={{ fontSize: "18px" }}>→</span>
          </a>

          {/* RELATED TITLE */}
          <div
            style={{
              borderTop: "1px solid #eee",
              paddingTop: "20px",
            }}
          >
            <div
              style={{
                color: "#999",
                fontSize: "10px",
                fontWeight: "700",
                letterSpacing: "1.3px",
                marginBottom: "5px",
              }}
            >
              YOU MAY ALSO LIKE
            </div>

            <h4
              style={{
                color: "#222",
                fontSize: "20px",
                margin: "0 0 15px",
                fontWeight: "700",
              }}
            >
              Related Designs
            </h4>

            {/* RELATED DESIGNS */}
            {related.length === 0 ? (
              <div
                style={{
                  padding: "20px",
                  textAlign: "center",
                  background: "#f8f8f8",
                  borderRadius: "8px",
                  color: "#888",
                  fontSize: "13px",
                }}
              >
                No related designs found.
              </div>
            ) : (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                  gap: "12px",
                }}
              >
                {related.map((item) => (
                  <Link
                   
                    to={`/video_gallery`}
                    onClick={() => setSelectedDesignId(null)}
                    style={{
                      textDecoration: "none",
                      color: "inherit",
                    }}
                  >
                    <div
                      style={{
                        background: "#fafafa",
                        border: "1px solid #eee",
                        borderRadius: "10px",
                        overflow: "hidden",
                        cursor: "pointer",
                      }}
                    >
                      {/* RELATED IMAGE */}
                      <div
                        style={{
                          width: "100%",
                          height: "115px",
                          overflow: "hidden",
                          background: "#eee",
                        }}
                      >
                        <img
                          src={uploadUrl(item.image)}
                          alt={
                            item.title ||
                            item.description ||
                            "Related Interior Design"
                          }
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                          }}
                        />
                      </div>

                      {/* RELATED TEXT */}
                      <div
                        style={{
                          padding: "10px",
                        }}
                      >
                        <h5
                          style={{
                            margin: "0 0 4px",
                            color: "#222",
                            fontSize: "13px",
                            fontWeight: "600",
                            lineHeight: "1.3",
                          }}
                        >
                          {item.title || "Interior Design"}
                        </h5>

                        <p
                          style={{
                            margin: 0,
                            color: "#888",
                            fontSize: "11px",
                            lineHeight: "1.4",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                          }}
                        >
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <style>
        {`
          @media (max-width: 767px) {
            .design-modal-body {
              grid-template-columns: 1fr !important;
            }
          }
        `}
      </style>
    </div>
  </div>
)}


        <Footer />
          <WhatsAppButton />
      <Chat/>
       <Call/>
      </div>
    </>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    padding: "20px",
  },

  modal: {
    background: "#fff",
    padding: "25px",
    borderRadius: "20px",
    width: "900px",
    maxWidth: "100%",
  },

  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
  },

  closeModal: {
    border: "none",
    background: "transparent",
    fontSize: "28px",
    cursor: "pointer",
  },

  modalBody: {
    display: "flex",
    flexWrap: "wrap",
    gap: "30px",
  },

  modalImage: {
    flex: "1",
  },

  modalImageImg: {
    width: "100%",
    borderRadius: "15px",
  },

  modalInfo: {
    flex: "1",
  },

  designSize: {
    marginTop: "15px",
  },

  relatedSection: {
    marginTop: "25px",
  },

  relatedGrid: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
  },

  relatedItem: {
    width: "120px",
    cursor: "pointer",
  },

  relatedItemImage: {
    width: "100%",
    borderRadius: "10px",
  },
};

export default DesignIdeas;